import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { injectIntl } from 'react-intl';

import Button from '../../../Button';
import { actions as cancelInvitation } from '../../../../redux/healthboard/requests/cancel-invitation-to-virtual-room-req';
import { selectCurrentAppointmentId } from '../../../../redux/healthboard/selectors';
import styles from './styles.styl';

const RemoveInvitationLink = ({ intl: { formatMessage }, close, email }) => {
  const dispatch = useDispatch();
  const appointmentId = useSelector(selectCurrentAppointmentId);

  const handleSubmit = () => {
    close();
    dispatch(cancelInvitation.send({ data: { appointmentId, email } }));
  };

  return (
    <div className={styles.root}>
      <div className={styles.description}>
        {formatMessage(
          { id: 'virtualVisit.removeInvitationLink.description' },
          { email },
        )}
      </div>
      <div className={styles.btnsSubmit}>
        <Button type="button" color="primary" raised onClick={handleSubmit}>
          {formatMessage({ id: 'common.remove' })}
        </Button>
        <Button type="button" raised color="accent" onClick={close}>
          {formatMessage({ id: 'common.cancel' })}
        </Button>
      </div>
    </div>
  );
};

RemoveInvitationLink.propTypes = {
  intl: PropTypes.object.isRequired,
  close: PropTypes.func,
  email: PropTypes.string,
};

export default injectIntl(RemoveInvitationLink);



// WEBPACK FOOTER //
// ./src/components/VirtualVideoRoom/Components/RemoveInvitationLinkForm/index.jsx